import React, { memo } from 'react';
import { FormWrapper } from './Wrappers';
import OutlinedInput, { OutlinedInputProps } from '@mui/material/OutlinedInput';

// A phone / payee number: 8–15 digits (covers Swedish mobile numbers and Swish merchant numbers).
export const isPhoneNumber = (v: string) => /^\d{8,15}$/.test(v)
const isPhoneNumberOrEmpty = (v: string) => v === '' || isPhoneNumber(v)

// Non-digits are stripped as you type. Pass `optional` to also accept an empty value; otherwise a
// valid number is required — two baked variants, one per validator.
const phoneAdapter =
  ({ onChange, ...props }: { onChange: (newValue: string) => void } & Omit<OutlinedInputProps, 'onChange'>) =>
    <OutlinedInput {...props} autoComplete='off' inputProps={{ inputMode: 'numeric', maxLength: 15 }}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, ''))} />
const RequiredPhoneField = FormWrapper({ Component: phoneAdapter, validationFunction: isPhoneNumber })
const OptionalPhoneField = FormWrapper({ Component: phoneAdapter, validationFunction: isPhoneNumberOrEmpty })

type PhoneInputProps = {
  label?: string, value: string, disabled?: boolean, sx?: {}, optional?: boolean,
  onChange: (newValue: string) => void,
}
const PhoneInput = memo(({ optional, ...props }: PhoneInputProps) =>
  optional ? <OptionalPhoneField {...props} /> : <RequiredPhoneField {...props} />)

export default PhoneInput
